import React from 'react';

import { UploadFilesPanel } from '@bingads-webui-campaign-react/ads-studio-app-components';
import { notificationApi } from '../../adapters/get-notification';

const globalLegacyI18n = window && window.globalLegacyI18n;

export const UploadFilesPanelPage = props => (
  <UploadFilesPanel {...props} notificationApi={notificationApi} globalLegacyI18n={globalLegacyI18n} />
);
